/* eslint-disable @typescript-eslint/camelcase */
import React from 'react';
import i18n from 'i18n';
import { connect } from 'react-redux';
import { getDashboardRequest } from 'modules/dashboard/actions';
import ApplicationState from 'store/interfaces';
import { DashboardDataCompanyFields } from 'modules/dashboard/interfaces';
import { numberWithDots } from 'utils/helpers';
import { CompanyData } from 'modules/authenticate/interfaces';
import MainPanelTemplate from '../templates';
import { ClientsPanel } from '..';

interface Props {
  getDashboardRequest: (props) => void;
  companySelected: CompanyData | null;
  companyDashboardData: DashboardDataCompanyFields;
  isLoading: boolean;
}

const EnvironmentsPanel = ({
  companyDashboardData,
  companySelected,
  getDashboardRequest,
  isLoading,
}: Props) => {
  React.useEffect(() => {
    if (companySelected) {
      getDashboardRequest({ companyUuid: companySelected?.id });
    }
  }, [companySelected, getDashboardRequest]);

  return (
    <>
      <MainPanelTemplate
        headerPage={{
          title: `${i18n.t('COMPANY_KEY')} AUTO.SKY`,
        }}
        cardLoading={isLoading}
        cards={[
          {
            type: 'company',
            title: 'PANEL_PAGE.TOTAL_PARTNER_KEY',
            value: numberWithDots(companyDashboardData.summary?.partners_count),
            key: 'companyDashboardData.summary.partners_count',
          },

          {
            type: 'company',
            title: 'PANEL_PAGE.QUALITY_ENVIRONMENTS_KEY',
            key: 'companyDashboardData.summary.environments_count',
            value: numberWithDots(
              companyDashboardData.summary?.environments_count
            ),
          },
          {
            type: 'company',
            title: 'INSTANCES_KEY',
            key: 'companyDashboardPartnerData.summary.environments_count',
            value: numberWithDots(
              companyDashboardData?.summary?.instances_count
            ),
          },

          {
            type: 'company',
            title: 'PANEL_PAGE.TOTAL_CLIENTS_KEY',
            value: numberWithDots(companyDashboardData.summary?.clients_count),
            key: 'companyDashboardData.summary.clients_count',
          },
          {
            type: 'company',
            title: 'PANEL_PAGE.TOTAL_USERS_KEY',
            value: numberWithDots(companyDashboardData.summary?.users_count),
            key: 'companyDashboardData.summary.users_count',
          },
          {
            type: 'company',
            title: 'TOTAL_SESSIONS_ACTIVE_KEY',
            value: numberWithDots(companyDashboardData.summary?.sessions_count),
            key: 'companyDashboardData.summary.sessions_count',
          },
        ]}
      />
      <ClientsPanel />
    </>
  );
};

const mapStateToProps = ({
  dashboard: { companyDashboardData, isLoading },
  authenticate: { companySelected },
}: ApplicationState) => ({
  companyDashboardData,
  companySelected,
  isLoading,
});

export default connect(mapStateToProps, { getDashboardRequest })(
  EnvironmentsPanel
);
